<template>
    <footer class="footer-area bg-cover">
        <div class="container">
            <div class="footer-top">
                <div class="row">
                    <div class="col-lg-6 align-self-center mb-4 mb-lg-0">
                        <h2 class="animate-text-footer">
                            <span class="waviy ms-2">
                                <span style="--i:1">T</span>
                                <span style="--i:2">r</span>
                                <span style="--i:3">a </span>
                                <span style="--i:4">b</span>
                                <span style="--i:5">a</span>
                                <span style="--i:6">j</span>
                                <span style="--i:7">e</span>
                                <span style="--i:8">m</span>
                                <span style="--i:9">o</span>
                                <span style="--i:10">s</span>
                                

                                <span class="ms-2" style="--i:11">J</span>
                                <span style="--i:12">u</span>
                                <span style="--i:13">n</span>
                                <span style="--i:14">t</span>
                                <span style="--i:15">o</span>
                                <span style="--i:16">s</span>
                                <span style="--i:17">!</span>
                            </span>
                        </h2>
                        <p>Para informacion y soporte, <router-link to="/contact-us">Contáctanos.</router-link></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="widget widget_about pe-xl-4">
                        <h4 class="widget-title">Ubicación</h4>
                        <div class="details">
                            <p>Calle Del Nogal 20 norte, Tabachines 1. Los Mochis, Sinaloa - CP: 81257</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="widget widget_about">
                        <h4 class="widget-title">Email</h4>
                        <div class="details">
                            <p>contacto@smaco.biz</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="widget widget_about">
                        <h4 class="widget-title">Teléfono</h4>
                        <div class="details">
                            <p>+52 (668) 165-3819 </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="widget widget_about">
                        <h4 class="widget-title">Horario</h4>
                        <div class="details">
                            <p>Lun - Vie: 8am – 5pm </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="footer-bottom">
                <div class="row">
                    <div class="col-lg-4 align-self-center mb-1 mb-lg-0">
                        <p>Copyright © 2023 Smaco.</p>
                        <p>Todos los Derechos Reservados.</p>
                    </div>
                    <div class="col-lg-5 align-self-center text-lg-center mb-3 mb-lg-0">
                        <p>Política de privacidad / Términos y servicios.</p>
                    </div>
                    <!-- <div class="col-lg-3 text-lg-end">
                        <ul class="social-media">
                            <li>
                                <a class="facebook" href="javascript:void(0)">
                                    <i class="fab fa-facebook-f"></i>
                                </a>
                            </li>
                            <li>
                                <a class="twitter" href="javascript:void(0)">
                                    <i class="fab fa-twitter"></i>
                                </a>
                            </li>
                            <li>
                                <a class="instagram" href="javascript:void(0)">
                                    <i class="fab fa-instagram"></i>
                                </a>
                            </li>
                            <li>
                                <a class="youtube" href="javascript:void(0)">
                                    <i class="fab fa-youtube"></i>
                                </a>
                            </li>
                        </ul>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- back to top area start -->
        <div class="back-to-top">
            <span class="back-top" @click="scrollToTop">Regresar</span>
        </div>
        <!-- back to top area end -->
    </footer>
</template>

<script>
    export default {
        name: "Footer",
        methods: {
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            },
        },
    }
</script>

<style scoped>
.footer-area {
    background-image: url('~@/assets/img/bg/12.png');
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Footer.vue